import React from 'react';
import { SHeader1, SSection } from '../../styles';
import { SubmittedFile } from '../components/SubmittedFile';

export const ProjectDescription = ({ title, state }) => {
  return (
    <SSection>
      <SHeader1>{title}</SHeader1>
      <SubmittedFile state={state} />
    </SSection>
  );
};
